export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 50;
